import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { NavigationLibraryService } from '../../services/navigation/navigation.service';
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-no-internet',
  templateUrl: './no-internet.component.html',
  styleUrls: ['./no-internet.component.scss'],
})
export class NoInternetComponent implements OnChanges {
  @Input() isNoInternet: boolean = false;
  constructor(
    private readonly navService: NavigationLibraryService,
    private readonly toast: ToastService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isNoInternet']?.currentValue === true) {
      setTimeout(() => {
        this.navService.setIndexContainer('container-right', 0);
        this.navService.focusContainer('container-right', true, 0, true);
      }, 150);
    }
  }

  networkRetry(event: any) {
    event.preventDefault();
    event.stopPropagation();
    this.toast.info('network_retry');
  }

  onBackClick(event: Event) {
    if (navigator.userAgent.includes('Tizen')) {
      window.tizen?.application.getCurrentApplication().exit();
    } else {
      window.close();
    }
    event.preventDefault();
    event.stopPropagation();
  }

  handleKeydown(event: KeyboardEvent) {
    if (event.isBack()) {
      this.onBackClick(event);
    } else {
      this.stopPropagation(event);
    }
  }

  private stopPropagation(event: any) {
    if (this.isNoInternet === true) {
      event.stopPropagation();
      event.preventDefault();
    }
  }
}
